import { Button } from '@shared/components/button';
import { Link } from '@shared/components/link';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { getDATRateViewUrl } from '../../utils/getDATRateUrl';
import { LinkToRateProps } from './types';

export function LinkToDATRate(p: LinkToRateProps) {
  const rateUrl = getDATRateViewUrl(p.quote);

  if (!rateUrl) return <div />;

  return (
    <Link size="xs" href={rateUrl} target="_blank" className="link">
      <div>
        <Button
          size="xs"
          icon={<MdOutlineOpenInNew className="text-brand-500" />}
          tooltip={p.optionalLabel || 'View rate source'}
          variant="tertiary"
          iconPosition="right"
        >
          {p.optionalLabel || 'View rate source'}
        </Button>
      </div>
    </Link>
  );
}
